import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useResponsive } from '@/hooks/use-responsive';
import { themeVar } from '@/styles/theme';
import { Helmet as Head } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { FirebaseLogin } from '../../components/authentication/login';

const Login = () => {
  const { isMobile, isTablet, isPortrait } = useResponsive();
  const location = useLocation();

  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    if (location.state?.isLastPageProfile) {
      setShowNotification(true);
    }
    const timerId = setTimeout(() => {
      setShowNotification(false);
    }, 10000);
    return () => clearTimeout(timerId);
  }, []);

  return (
    <>
      <Head>
        <title>Login</title>
      </Head>
      {isMobile || (isPortrait && isTablet) ? (
        <LogInBlockMobile>
          <FirebaseLogin />
          {showNotification && <LogOutNotification>You have been signed out</LogOutNotification>}
        </LogInBlockMobile>
      ) : (
        <LogInBlock>
          <FirebaseLogin />
          {showNotification && <LogOutNotification>You have been signed out</LogOutNotification>}
        </LogInBlock>
      )}
      {isMobile || (isPortrait && isTablet) ? (
        <Annotation color={'#36474F'}>{`@${new Date().getFullYear()} WECtec Enterprises, LLC`}</Annotation>
      ) : (
        <></>
      )}
    </>
  );
};

export default Login;

const LogOutNotification = styled.div<{ color?: string }>`
  width: 300px;
  background: #76e7cd;
  color: ${({ color }) => color};
  padding: 14px 16px;
  margin-top: 30px;
  opacity: 0.9;
  border-radius: 6px;
  font-family: Inter, serif;
  font-weight: 500;
  text-align: center;
`;

const LogInBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 50%;
  overflow: hidden;
  position: relative;
  background-color: ${themeVar('layer.base')};
`;

const LogInBlockMobile = styled(LogInBlock)`
  width: 100%;
`;

const Annotation = styled.span`
  text-align: center;
  color: #36474f;
  font-size: 14px;
  font-family: Inter, serif;
  padding-bottom: 10px;
`;
